import { recentActivity } from "@/mocks/dashboard";

const colorMap: Record<string, { bg: string; icon: string }> = {
  emerald: { bg: "bg-emerald-100", icon: "text-emerald-600" },
  amber: { bg: "bg-amber-100", icon: "text-amber-600" },
  sky: { bg: "bg-sky-100", icon: "text-sky-600" },
  violet: { bg: "bg-violet-100", icon: "text-violet-600" },
  orange: { bg: "bg-orange-100", icon: "text-orange-600" },
};

export default function ActivityFeed() {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-history-line text-base text-gray-600"></i>
          </div>
          <h3 className="font-semibold text-gray-900 text-sm">Son Aktiviteler</h3>
        </div>
        <button className="text-xs text-[#25D366] font-medium hover:underline cursor-pointer whitespace-nowrap">
          Tümünü Gör
        </button>
      </div>
      <div className="divide-y divide-gray-50">
        {recentActivity.map((item, i) => {
          const c = colorMap[item.color] || colorMap.emerald;
          return (
            <div key={i} className="flex items-start gap-3 px-5 py-3.5 hover:bg-gray-50/50 transition-colors">
              <div className={`w-8 h-8 flex items-center justify-center rounded-xl flex-shrink-0 ${c.bg}`}>
                <i className={`${item.icon} text-sm ${c.icon}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-700 leading-snug">{item.text}</p>
                <p className="text-xs text-gray-400 mt-0.5">{item.time}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}